<template>
  <div class="preview">
    <div v-if="!noHeader" class="preview__header">
      {{ $t('components.SurveyCompleteFormPreview.preview') }}
    </div>
    <div class="preview__content">
      <img v-if="survey.complete.mediaImage" :src="survey.complete.mediaImage.url" alt="" class="preview__image">
      <div v-else class="preview__brandImage">
        <div class="preview__brandImage__icon">
          <Icon name="iconQuestion" />
        </div>
        <p>{{ $t('components.SurveyCompleteFormPreview.logoNote') }}</p>
      </div>
      <p class="preview__title">{{ survey.complete.title }}</p>
      <p class="preview__description">{{ survey.complete.text }}</p>
      <div v-if="survey.complete.showBtnForm" class="preview__button">
        {{ survey.complete.btnLabel }}
      </div>
      <template v-if="!survey.guideToReviewSite.delete">
        <Info class="preview__info">
          {{ $t('components.SurveyCompleteFormPreview.siteLinkNote') }}
        </Info>
        <div class="preview__section">
          <p class="preview__section__title">{{ survey.guideToReviewSite.title }}</p>
          <ul class="preview__siteLinks">
            <li class="preview__siteLinks__item">
              <p class="preview__siteLinks__name">例）口コミサイト名</p>
              <p class="preview__siteLinks__button">口コミを書く</p>
            </li>
          </ul>
        </div>
      </template>
      <Info class="preview__info">
        {{ $t('components.SurveyCompleteFormPreview.otherSettingsNote') }}
      </Info>
      <div class="preview__section">
        <p class="preview__section__title">SNSをフォローして最新情報を入手しよう</p>
        <ul class="preview__sns">
          <li class="preview__sns__item">
            <div class="preview__sns__icon preview__sns__icon--facebook">
              <img alt="" :src="iconFacebookPath">
            </div>
            <p class="preview__sns__name">Facebook</p>
            <a class="preview__sns__button" target="_blank" href="">{{ $t('labels.check') }}</a>
          </li>
          <li class="preview__sns__item">
            <div class="preview__sns__icon preview__sns__icon--twitter">
              <img alt="" :src="iconTwitterPath">
            </div>
            <p class="preview__sns__name">X</p>
            <a class="preview__sns__button" target="_blank" href="">{{ $t('labels.check') }}</a>
          </li>
          <li class="preview__sns__item">
            <div class="preview__sns__icon preview__sns__icon--instagram">
              <img alt="" :src="iconInstagramPath">
            </div>
            <p class="preview__sns__name">Instagram</p>
            <a class="preview__sns__button" target="_blank" href="">{{ $t('labels.check') }}</a>
          </li>
          <li class="preview__sns__item">
            <div class="preview__sns__icon preview__sns__icon--line">
              <img alt="" :src="iconLinePath">
            </div>
            <p class="preview__sns__name">LINE</p>
            <a class="preview__sns__button" target="_blank" href="">{{ $t('labels.check') }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './Icon'
import Info from './Info'
import iconFacebookPath from '../../../images/common/icon_facebook.svg'
import iconInstagramPath from '../../../images/common/icon_instagram.svg'
import iconLinePath from '../../../images/common/icon_line.svg'
import iconTwitterPath from '../../../images/common/icon_x.svg'

export default {
  name: 'SurveyCompleteFormPreview',
  components: {
    Icon,
    Info,
  },
  props: {
    survey: {
      type: Object,
      required: true,
    },
    noHeader: {
      type: Boolean,
    },
  },
  data () {
    return {
      iconFacebookPath,
      iconInstagramPath,
      iconLinePath,
      iconTwitterPath,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
.preview {
  $root: #{&};
  pointer-events: none;
  cursor: not-allowed;
  &__header {
    padding: 16px 32px;
    border-bottom: 1px solid #E4E7EB;
  }
  &__content {
    padding: 24px 20px;
  }
  &__image {
    width: 100%;
  }
  &__brandImage {
    display: flex;
    align-items: center;
    width: 176px;
    height: 176px;
    margin: 16px auto 24px;
    padding: 16px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgb(0 0 0 / 6%);
    background: #F5F6F9;
    font-size: 12px;
    line-height: 1.5;
    &__icon {
      margin-right: 8px;
      svg {
        fill: #3A3B3F;
      }
    }
  }
  &__title {
    margin-top: 40px;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
  }
  &__description {
    margin-top: 6px;
    font-size: 14px;
    line-height: 1.71;
    white-space: pre-wrap;
    + #{$root}__button {
      margin-top: 40px;
    }
  }
  &__info {
    margin-top: 40px;
  }
  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 280px;
    height: 48px;
    margin: 24px auto 0;
    padding: 32px 30px;
    border-radius: 10px;
    background: $color-accent-primary;
    color: #FFF;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.5;
    text-decoration: none;
  }
  &__siteLinks {
    &__item {
      display: flex;
      align-items: center;
      padding: 24px 16px 24px 24px;
      border-radius: 10px;
      background: #F4F4F4;
    }
    &__name {
      flex-grow: 1;
      padding-right: 8px;
      font-weight: bold;
      font-size: 16px;
      line-height: 1.5;
    }
    &__button {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 120px;
      height: 34px;
      padding: 0 24px 1px;
      border-radius: 17px;
      background-color: #E9446A;
      color: #FFF;
      font-weight: bold;
      font-size: 12px;
      line-height: 1;
      text-decoration: none;
      white-space: nowrap;
    }
  }
  &__section {
    #{$root}__section {
      margin-top: 40px;
    }
    &__title {
      margin-bottom: 8px;
      font-weight: bold;
      font-size: 14px;
      line-height: 1.71;
    }
  }
  &__sns {
    padding: 0 24px;
    border-radius: 10px;
    background-color: #F4F4F4;
    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24px 0;
      &:not(:first-child) {
        border-top: 1px solid #E6EBF0;
      }
    }
    &__icon {
      display: flex;
      flex-basis: 40px;
      justify-content: center;
      align-items: center;
      min-width: 40px;
      min-height: 40px;
      border-radius: 50%;
      &--facebook {
        width: 10px;
        background-color: #3856A2;
      }
      &--twitter {
        width: 18px;
        background-color: #000;
      }
      &--instagram {
        width: 22px;
        background: radial-gradient(99.11% 99.11% at 26.56% 107.7%, #FD5 0%, #FD5 10%, #FF543E 50%, #C837AB 100%);
      }
      &--line {
        width: 24px;
        background-color: #00B900;
      }
    }
    &__name {
      font-weight: bold;
      font-size: 14px;
      line-height: 1.71;
      &:not(:first-child) {
        margin-left: 16px;
      }
    }
    &__button {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 98px;
      height: 34px;
      margin-left: auto;
      padding: 0 24px 1px;
      border-radius: 17px;
      background-color: #ECECEC;
      font-weight: bold;
      font-size: 12px;
      line-height: 1;
      text-decoration: none;
      white-space: nowrap;
      transition: .2s;
      &:hover {
        background-color: darken(#ECECEC, 5%);
      }
    }
  }
}
</style>
